import React from 'reactn';
import { IMPRENDITORE, IMPRESA_FAMILIARE, PROFESSIONE, SRL_NON_TRASPARENTE, SRL_TRASPARENTE } from '../../states/BudgetState';
import ImpresaFamiliare from './ImpresaFamiliare';
import { SchedaBudgetInputProps } from './InformazioniCosti';
import IRAP from './IRAP';
import PersonaFisicaImprenditore from './PersonaFisicaImprenditore';
import PersonaFisicaProfessionista from './PersonaFisicaProfessionista';
import SocietaDiPersoneSrlRegTrasparenza from './SocietaDiPersoneSrlRegTrasparenza';
import SrlNonTrasparente from './SrlNonTrasparente';

export default function ImposteContributi(props: SchedaBudgetInputProps) {

    //const gClasses = globalStyles();
    const { state } = props;

    const handleChangeChild = (act: string, name: string, value: any) => {
        props.handleChange(act, name, value);
    }

    return (
        <React.Fragment>
            <IRAP state={state} handleChange={handleChangeChild}></IRAP>
            {IMPRENDITORE(state) === true ?
            <PersonaFisicaImprenditore state={state} handleChange={handleChangeChild}></PersonaFisicaImprenditore> :
            PROFESSIONE(state) === true ?
            <PersonaFisicaProfessionista state={state} handleChange={handleChangeChild}></PersonaFisicaProfessionista> :
            IMPRESA_FAMILIARE(state) === true ?
            <ImpresaFamiliare state={state} handleChange={handleChangeChild}></ImpresaFamiliare> :
            SRL_TRASPARENTE(state) === true ?
            <SocietaDiPersoneSrlRegTrasparenza state={state} handleChange={handleChangeChild}></SocietaDiPersoneSrlRegTrasparenza> :
            SRL_NON_TRASPARENTE(state) === true ?
            <SrlNonTrasparente state={state} handleChange={handleChangeChild}></SrlNonTrasparente> :
            <p></p>}
        </React.Fragment>
    )
}